import { getCreditBatch } from '../../../api/creditBatchApi'
import LinkButton from '../../../components/link-button/link-button'
import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import {
  getCreditBatchReferenceTypeLabel,
  getCreditBatchSourceTypeLabel,
  getCreditBatchStatusLabel,
  getCreditBatchTransactionTypeLabel,
} from '../constant'
import { CreditBatchReferenceType, ICreditBatchDetails } from '../share-type'
import { Card, Col, Descriptions, Row, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const localPagination = {
  defaultPageSize: 10,
  showSizeChanger: true,
  hideOnSinglePage: true,
  pageSizeOptions: [10, 20, 50],
}

const CreditBatch = () => {
  const { id } = useParams()
  const [details, setDetails] = useState<ICreditBatchDetails>()

  useEffect(() => {
    if (id) {
      getCreditBatch(Number(id)).then(setDetails)
    }
  }, [id])

  if (!details) {
    return null
  }

  const { creditBatch, transactions } = details
  const transactionColumns: ColumnsType<ICreditBatchDetails['transactions'][number]> = [
    { title: 'ID', dataIndex: 'id' },
    {
      title: translate('creditBatches.transactionType'),
      dataIndex: 'type',
      render: getCreditBatchTransactionTypeLabel,
    },
    { title: translate('creditBatches.transactionCredits'), dataIndex: 'credits' },
    {
      title: translate('creditBatches.referenceType'),
      dataIndex: 'referenceType',
      render: getCreditBatchReferenceTypeLabel,
    },
    {
      title: translate('creditBatches.referenceId'),
      render: record =>
        record.referenceType === CreditBatchReferenceType.ORDER ? (
          <LinkButton to={`/order-histories/${record.referenceId}`}>
            {record.referenceId}
          </LinkButton>
        ) : (
          record.referenceId
        ),
    },
    { title: translate('creditBatches.createdBy'), dataIndex: 'createdBy' },
    {
      title: translate('creditBatches.createdAt'),
      dataIndex: 'createdAt',
      render: value => getDateTime(value),
    },
  ]

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} xl={12}>
        <Card title={translate('creditBatches.detailTitle')}>
          <Descriptions
            bordered
            column={1}
            size="small"
            styles={{ label: { alignItems: 'center', fontWeight: 600, width: 220 } }}
          >
            <Descriptions.Item label="ID">{creditBatch.id}</Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.userId')}>
              {creditBatch.userId}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.sourceType')}>
              {getCreditBatchSourceTypeLabel(creditBatch.sourceType)}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.sourceId')}>
              {creditBatch.sourceId}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.issuedCredits')}>
              {creditBatch.issuedCredits}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.remainingCredits')}>
              {creditBatch.remainingCredits}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.status')}>
              {getCreditBatchStatusLabel(creditBatch.status)}
            </Descriptions.Item>
            <Descriptions.Item label={translate('creditBatches.expiresAt')}>
              {getDateTime(creditBatch.expiresAt)}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col xs={24} xl={12}>
        <Card title={translate('creditBatches.transactionsTitle')}>
          <Table
            size="small"
            rowKey="id"
            columns={transactionColumns}
            dataSource={transactions}
            pagination={localPagination}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default CreditBatch
